import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  useScrollTrigger,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import MenuCard from "./MenuCard";
import { useNavigate, useParams } from "react-router-dom";
import {
  getRestaurantById,
  getRestaurantCategory,
  getRestaurantsCategory,
} from "../State/Restaurant/Action";
import { useDispatch, useSelector } from "react-redux";
import { getMenuItemsByRestaurantId } from "../State/Menu/Action";

const categories = ["all", "pizza", "Biryani", "Chicken", "burger", "rice"];
const foodTypes = [
  { label: "All", value: "all" },
  { label: "Vegetarian only", value: "vegetarian" },
  { label: "Non-Vegetarian", value: "non-vegetarian" },
  { label: "Seasonal", value: "seasonal" },
];
const menu = [1, 1, 1, 1, 1];
const RestaurantDetails = () => {
  const [foodType, setFoodType] = useState("all");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { auth, restaurant, menu } = useSelector((store) => store);

  const [selectedCategory,setSelectedCategory]=useState("");
  const { id } = useParams();


  const handleFilter = (e) => {
    setFoodType(e.target.value)
    console.log(e.target.value, e.target.name);
  };
  const handleFilterCategory = (e,value) => {
    setSelectedCategory(value);
    console.log(e.target.value, e.target.name,value);
  };
  console.log("restaurant", restaurant);
  useEffect(() => {
    dispatch(getRestaurantById({ jwt, restaurantId: id }));
    dispatch(getRestaurantsCategory({ jwt, restaurantId: id }));
   
  }, []);
  useEffect(()=>{
    dispatch(
      getMenuItemsByRestaurantId({
        jwt,
        restaurantId: id,
        vegetarian: foodType==="vegetaraian",
        nonveg: foodType==="non_vegetaraian",
        seasonal: foodType==="seasonal",
        foodCategory: selectedCategory,
      })
    );
  },[selectedCategory,foodType])
  return (
    <div className="px-5 lg:px-20">
      <section>
        <h3>Home/india/indian fast food/3</h3>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <img
                className="w-full h-[40vh] object-cover "
                // src={restaurant.restaurant?.images[0]}
                src="https://cdn.pixabay.com/photo/2017/08/06/18/07/bistro-2594762_1280.jpg"
             
                alt=""
              />
            </Grid>
          </Grid>

          <Grid item xs={12} lg={6}>
            <img
              className="w-full h-[40vh] object-cover"
              // src={restaurant.restaurant?.images[1]}
              src="https://images.pexels.com/photos/4450334/pexels-photo-4450334.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
             
              alt=""
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <img
              className="w-full h-[40vh] object-cover"
              src="https://cdn.pixabay.com/photo/2017/08/06/18/07/bistro-2594762_1280.jpg"
              alt=""
            />
          </Grid>
        </div>
        <div className="pt-3 pb-5">
          <h1 className="text-4xl font-semibold">
            {restaurant.restaurant?.name}
          </h1>
          <p className="text-gray-500 mt-1">
            {restaurant.restaurant?.description}
          </p>

          <div className="space-y-3 mt-3">
            <p className="text-gray-500 flex items-center gap-3">
              <LocationOnIcon />
              <span>Mumbai, Mahastra</span>
            </p>
            <p className="text-gray-500 flex items-center gap-3">
              <CalendarTodayIcon />
              <span>Mon - Sun: 9:00 AM - 9:00 PM (Today)</span>
            </p>
          </div>
        </div>
      </section>
      <Divider />
      <section className="pt-[2rem] lg:flex relative">
        <div className="space-y-10 lg:w-[20%] filter ">
          <div className="box space-y-5 lg:sticky top-28 d">
            <div>
              <Typography variant="h5" sx={{ paddingBottom: "1rem" }}>
                Food Type
              </Typography>
              <FormControl className="py-10 space-y-5 " components={"fieldset"}>
                <RadioGroup
                  onChange={handleFilter}
                  name="food_type"
                  value={foodType}
                >
                  {foodTypes.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      value={item.value}
                      control={<Radio />}
                      label={item.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
            <Divider />
            <div>
              <Typography variant="h5" sx={{ paddingBottom: "1rem" }}>
                Food Category
              </Typography>

              {/* <FormControl className="py-10 space-y-5 " components={"fieldset"}>
                <RadioGroup
                  onChange={handleFilterCategory}
                  name="food_category"
                  value={selectedCategory}
                >
                  {restaurant.categories.map((item) => (
                    <FormControlLabel
                      key={item}
                      value={item.name}
                      control={<Radio />}
                      label={item.name}
                    />
                  ))}
                  {
                    categories.map((item)=>
                    <FormControlLabel
                    key={item}
                    value={item}
                    label={item}
                    />)
                  }
                </RadioGroup>
              </FormControl> */}
              <FormControl className="py-10 space-y-5 " components={"fieldset"}>
                <RadioGroup
                  onChange={handleFilterCategory}
                  name="food_category"
                  value={selectedCategory}
                >
                {
                    categories.map((item)=>
                    <FormControlLabel
                    key={item}
                    value={item}
                    label={item}
                    control={<Radio/>}
                    />)
                  }
                  
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
        <div className="space-y-5 lg:w-[80%] lg:pl-10">
          {/* {menu.menuItems.map((item) => (
            <MenuCard item={item} />
          ))} */}
          <MenuCard  />
          
        </div>
      </section>
    </div>
  );
};

export default RestaurantDetails;
